import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getMonthlyBatchSales } from "../../api";

function BatchChart({ selectedYear, powerappId }) {
    const [noData, setNoData] = useState(true);
    const [options, setOptions] = useState({
        chart: {
            height: 350,
            type: "bar",
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    position: "top", // top, center, bottom
                },
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (val) {
                return val + "$";
            },
            offsetY: -20,
            style: {
                fontSize: "12px",
                colors: ["#304758"],
            },
        },

        xaxis: {
            categories: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
            position: "top",
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            crosshairs: {
                fill: {
                    type: "gradient",
                    gradient: {
                        colorFrom: "#D8E3F0",
                        colorTo: "#BED1E6",
                        stops: [0, 100],
                        opacityFrom: 0.4,
                        opacityTo: 0.5,
                    },
                },
            },
            tooltip: {
                enabled: true,
            },
        },
        yaxis: {
            axisBorder: {
                show: true,
            },
            axisTicks: {
                show: true,
            },
            labels: {
                show: true,
                formatter: function (val) {
                    return val + "$";
                },
            },
            max: 1200,
        },
        title: {
            text: "Monthly Batch Sales, 2024",
            floating: true,
            offsetY: 330,
            align: "center",
            style: {
                color: "#444",
            },
        },
    });

    const [series, setSeries] = useState([
        {
            name: "Sales",
            data: [
                800.3, 700.1, 600.0, 500.1, 400.0, 300.6, 200.2, 200.3, 1000.4,
                800.8, 900.5, 100.2,
            ],
        },
    ]);

    useEffect(() => {
        getMonthlyBatchSales({
            year: selectedYear,
            powerapp_id: powerappId,
        }).then((res) => {
            setSeries([
                {
                    name: "Sales",
                    data: res.data,
                },
            ]);

            setOptions({
                chart: {
                    height: 350,
                    type: "bar",
                },
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        dataLabels: {
                            position: "top", // top, center, bottom
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return "$" + val;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: "12px",
                        colors: ["#304758"],
                    },
                },

                xaxis: {
                    categories: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec",
                    ],
                    position: "top",
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                    crosshairs: {
                        fill: {
                            type: "gradient",
                            gradient: {
                                colorFrom: "#D8E3F0",
                                colorTo: "#BED1E6",
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            },
                        },
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                yaxis: {
                    forceNiceScale: true,
                    axisBorder: {
                        show: true,
                    },
                    axisTicks: {
                        show: true,
                    },
                    labels: {
                        show: true,
                        formatter: function (val) {
                            return "$" + val;
                        },
                    },
                    max: res.max,
                },
                title: {
                    text: "Monthly Batch Sales, 2024",
                    floating: true,
                    offsetY: 330,
                    align: "center",
                    style: {
                        color: "#444",
                    },
                },
            });

            const sum = res.data.reduce(
                (accumulator, currentValue) => +accumulator + +currentValue,
                0,
            );
            if (sum > 0) {
                setNoData(false);
            } else {
                setNoData(true);
            }
        });
    }, [selectedYear]);

    return (
        <div>
            {noData ? (
                <h6>No Data</h6>
            ) : (
                <ReactApexChart
                    options={options}
                    series={series}
                    type="bar"
                    height={350}
                />
            )}
        </div>
    );
}

export default BatchChart;
